import { DisplayOptions } from '../../constants/shlapp';

export const getDisplayOptionsStatus = (displayOptions: DisplayOptions[]): boolean => {
  return displayOptions.indexOf(DisplayOptions.MOBILE_APP) > -1;
};
